import { selectDashboard } from '@store/reducers/dashboard/selectors'
import type { Workspace } from '@store/reducers/dashboard/types'
import { call, put, select } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'
import {
  type DashboardActions,
  InternalFolderActions as Internal,
  InternalProjectActions,
} from '../../actions'
import { findFolder } from '../../utils'

export function* deleteSaga({
  payload: { workspaceId, id },
}: ReturnType<typeof DashboardActions.folders.delete>) {
  const dashboard: Workspace[] = yield select(selectDashboard)

  const projects = (findFolder(id, workspaceId, dashboard)?.projects || []).map(
    (f) => ({ ...f, folderId: null, archived: true })
  )

  sendGtmEvent(GtmTriggerName.DASHBOARD_FOLDER_DELETE)

  yield put(InternalProjectActions.massArchive({ workspaceId, projects }))
  yield put(Internal.delete({ workspaceId, id }))
  yield call(NestClient.folders.delete, workspaceId, { id })
}
